import { UserInfoActionTypes } from '@state/features/common.types';
import { isUserAuthenticated } from '@state/features/orders.selectors';
// import analytics from '@utils/analytics';
import api from '@utils/api';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import AftercareDetail from '../clientService/AftercareDetail';
import ClientServiceSection from '../clientService/ClientServiceSection';
import Accordion from '@common/ui/accordion/Accordion';
import OrderReturnsItem from '../returns/OrderReturnsItem';
import OrderHistoryItem from '../account/OrderHistoryItem';
import TrackingOrderForm from './TrackingOrderForm';
const Tracking = (props) => {
    const { t } = useTranslation();
    const [orderList, setOrderList] = useState();
    const [returnList, setReturnList] = useState();
    const [aftercareList, setAftercareList] = useState();
    const [aftercareDetail, setAftercareDetail] = useState();
    const { loading: waitingUserInfo, user: { isAuthenticated }, } = useSelector(isUserAuthenticated);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch({
            type: UserInfoActionTypes.FETCH_USERINFO,
        });
    }, []);
    useEffect(() => {
        if (isAuthenticated) {
            api.getOrders().then(setOrderList);
            api.getReturns().then(setReturnList);
            api.getAftercares().then(setAftercareList);
        }
    }, [isAuthenticated]);
    const authenticatedOrderList = () => {
        return (React.createElement(React.Fragment, null,
            !props.aftercareonly && (React.createElement(ClientServiceSection, { title: t('tracking.trackyourorders'), introSection: true },
                React.createElement("div", { className: "orders-listing__intro" }, t('tracking.selectanorder')),
                React.createElement("div", { className: "orders-listing--cs" }, (orderList === null || orderList === void 0 ? void 0 : orderList.length) ? (React.createElement(Accordion, null, orderList.map((order) => (React.createElement(OrderHistoryItem, { key: `order-${order.orderNumber}`, order: order, orderNumberActive: order === null || order === void 0 ? void 0 : order.orderNumber, orderdetail: '', hideCtas: true, type: "clientservice" }))))) : (React.createElement("div", { className: "tracking__no-item" }, t('tracking.noorderfound')))))),
            !props.aftercareonly && (React.createElement(ClientServiceSection, { title: t('tracking.trackyourreturn') },
                React.createElement("div", { className: "orders-listing__intro" }, t('tracking.selectareturn')),
                React.createElement("div", { className: "orders-listing--cs" }, (returnList === null || returnList === void 0 ? void 0 : returnList.length) ? (React.createElement(Accordion, null, returnList.map((order) => (
                // TODO - Check with <OrderReturnsItem /> ---------------------
                React.createElement(OrderReturnsItem, { key: `return-${order.returnCaseNumber}`, order: order }))))) : (React.createElement("div", { className: "tracking__no-item" }, t('tracking.noreturnsfound')))))),
            React.createElement(ClientServiceSection, { title: t('tracking.trackyouraftercare'), introSection: !!props.aftercareonly },
                React.createElement("div", { className: "orders-listing__intro" }, t('tracking.selectaftercare')),
                (aftercareList === null || aftercareList === void 0 ? void 0 : aftercareList.length) ? (React.createElement(Accordion, null, aftercareList.map((aftercare) => (React.createElement(AftercareDetail, { key: `aftercare-${aftercare.code}`, aftercare: aftercare }))))) : (React.createElement("div", { className: "tracking__no-item" }, t('tracking.noaftercarefound')))),
            React.createElement(TrackingOrderForm, { aftercareurl: props.aftercareurl, orderdetailurl: props.orderdetail, returndetailurl: props.returndetailurl, onSubmitCallback: setAftercareDetail })));
    };
    if (aftercareDetail) {
        return (React.createElement(React.Fragment, null,
            aftercareDetail && React.createElement(AftercareDetail, { trackingurl: props.trackingurl, aftercare: aftercareDetail }),
            React.createElement("div", { className: "line" }),
            React.createElement(TrackingOrderForm, { aftercareurl: props.aftercareurl, orderdetailurl: props.orderdetail, returndetailurl: props.returndetailurl, onSubmitCallback: setAftercareDetail, anotherone: true })));
    }
    if (waitingUserInfo) {
        return React.createElement("div", { className: "hiddenloading" });
    }
    if (isAuthenticated) {
        return authenticatedOrderList();
    }
    else {
        return (React.createElement(TrackingOrderForm, { aftercareurl: props.aftercareurl, orderdetailurl: props.orderdetail, returndetailurl: props.returndetailurl, onSubmitCallback: setAftercareDetail, introSection: true }));
    }
};
export default Tracking;
